<div class="bpaas-access-denied">
  <div class="card">
    <div class="flex flex-column align-items-center justify-content-center card-container h-screen">
        <div class="bpaas-exception-title mb-3">ACCESS DENIED</div>
        <div class="bpaas-exception-detail mb-7">You do not have the necessary permissions.</div>
        <div class="bpaas-exception-detail mb-3">
          <button pButton pRipple btnback type="button" class="p-button-danger">
            Back to Dashborad
          </button>
        </div>
    </div>
  </div>
</div>
